$('.collection-discover .image-item').on('mouseenter',function (event){
    let pointerX = event.pageX;
    let pointerY = event.pageY;
    let top =$(event.target).closest('.image-item').offset().top;
    let left =$(event.target).closest('.image-item').offset().left;
    let height =$(event.target).closest('.image-item').height();
    let width =$(event.target).closest('.image-item').width();
    let overlay =$(event.target).closest('.image-item').find('.image-item-overlay');
    if(pointerY <= (top + 5 )){
        overlay.css('top','-100%')
        overlay.css('left','0')
        overlay.css('transition','unset')
        setTimeout(function (){
            overlay.css('left','0')
            overlay.css('top','0')
            overlay.css('transition','all 250ms linear 0s')
        },150)
    }else if(pointerY > top && (pointerY+5) <= (top+height) ){
        if((pointerX+5) <= (left+width) ){
            overlay.css('left','-100%')
            overlay.css('top','0')
            overlay.css('transition','unset')
            setTimeout(function (){
                overlay.css('left','0')
                overlay.css('top','0')
                overlay.css('transition','all 250ms linear 0s')
            },150)
        }else{
            overlay.css('left','100%')
            overlay.css('top','0')
            overlay.css('transition','unset')
            setTimeout(function (){
                overlay.css('left','0')
                overlay.css('top','0')
                overlay.css('transition','all 250ms linear 0s')
            },150)
        }
    }else if((pointerY+5) >= (top+height)){
        overlay.css('top','100%')
        overlay.css('left','0')
        overlay.css('transition','unset')
        setTimeout(function (){
            overlay.css('top','0')
            overlay.css('left','0')
            overlay.css('transition','all 250ms linear 0s')
        },150)
    }

})
$('.collection-discover .image-item').on('mouseleave',function (event){
    let pointerX = event.pageX;
    let pointerY = event.pageY;
    let top =$(event.target).closest('.image-item').offset().top;
    let left =$(event.target).closest('.image-item').offset().left;
    let height =$(event.target).closest('.image-item').height();
    let overlay =$(event.target).closest('.image-item').find('.image-item-overlay');
    if(pointerY <= top){
        overlay.css('left','0')
        overlay.css('top','-100%')
        setTimeout(function (){
            overlay[0].removeAttribute('style')
        },300)
    }else if(pointerY > top && (pointerY+5) <= (top+height) ){
        if(pointerX <= left ){
            setTimeout(function (){
                overlay.css('left','-100%')
                overlay.css('top','0')
                setTimeout(function (){
                    overlay.css('transition','unset')
                    overlay[0].removeAttribute('style')
                },300)
            },100)
        }else{
            setTimeout(function (){
                overlay.css('left','100%')
                overlay.css('top','0')
                setTimeout(function (){
                    overlay.css('transition','unset')
                    overlay[0].removeAttribute('style')
                },300)
            },100)
        }
    }else if((pointerY+5) >= (top+height)){
        setTimeout(function (){
            overlay.css('left','0')
            overlay.css('top','100%')
            setTimeout(function (){
                overlay.css('transition','unset')
                overlay[0].removeAttribute('style')
            },300)
        },100)
    }
});
if($('body').hasClass('search')){
    $(document).on('click','.usf-sr-paging a',function (e){
        e.preventDefault();
        if(!$(this).parent().hasClass('next') && !$(this).parent().hasClass('prev')){
            const page = $(this).attr('href');
            if(page != 'javascript:void(0)'){
                if(location.href.includes('&page=')){
                    let pageHref = page.replace('?','&');
                    let curentPage = $(this).closest('.usf-sr-paging').find('.page.current')[0].innerHTML;
                    location.href = location.href.replace(`&page=${curentPage}`,pageHref);
                }else{
                    location.href = location.href + page.replace('?','&');
                }
            }
        }
    });
}
addReadMore();
addImageWithTextReadMore();
let previousWindowWidth = window.innerWidth;
$( window ).resize(function() {
    if(previousWindowWidth != window.innerWidth){
        addReadMore();
        addImageWithTextReadMore();
        previousWindowWidth = window.innerWidth;
    }
});
function addReadMore(){
    const description = $('.section.collection_description');
    if(description.length > 0){
        /*$('.section.collection_description')[0].scrollHeight*/
        let descriptionOriginalHeight = $('.section.collection_description')[0].scrollHeight;
        let firstElementHeight = $('.section.collection_description *:nth-child(1)').height() + parseInt($('.section.collection_description *:nth-child(1)').css("marginBottom").replace('px',''));
        let secondElementHeight = $('.section.collection_description *:nth-child(2)').height();
        let descriptionHeight = $('.section.collection_description')[0].scrollHeight;
        let descriptionChildHeight = 0;
        let desktopMaxHeight = 155
        let mobileMaxHeight = 105;
        if(description.hasClass('page_description')){
            mobileMaxHeight = 155;
        }
        if(description.hasClass('author-description')){
            desktopMaxHeight = 105;
        }
        if(description.hasClass('photo_description')){
            if(firstElementHeight <= desktopMaxHeight ){
                desktopMaxHeight = firstElementHeight - parseInt($('.section.collection_description *:nth-child(1)').css("marginBottom").replace('px',''));
            }
            if(firstElementHeight <= mobileMaxHeight ){
                mobileMaxHeight = firstElementHeight - parseInt($('.section.collection_description *:nth-child(1)').css("marginBottom").replace('px',''));
            }
        }
        if(secondElementHeight != undefined){
            descriptionChildHeight =  firstElementHeight + secondElementHeight;
        }else{
            descriptionChildHeight =  firstElementHeight - parseInt($('.section.collection_description *:nth-child(1)').css("marginBottom").replace('px',''));
        }
        if (window.matchMedia("(max-width: 768px)").matches) {
            if(descriptionOriginalHeight > mobileMaxHeight){
                if(descriptionHeight != Math.round(descriptionChildHeight) || descriptionChildHeight > mobileMaxHeight){
                    if(descriptionChildHeight < mobileMaxHeight){
                        description.css('height', (descriptionChildHeight+2) +'px');
                    }else{
                        description.css('height', mobileMaxHeight+'px');
                    }
                    if(description.hasClass('read-more')) {
                        $('.description-read-more-btn').remove();
                    }
                    description.addClass('read-more')
                    description.after('<div class="description-read-more-btn">Read more</div>');
                    $('.description-read-more-btn').on('click', function () {
                        if($(this).hasClass('show-less')){
                            if(descriptionChildHeight < mobileMaxHeight){
                                description.css('height', (descriptionChildHeight+2) +'px');
                            }else{
                                description.css('height', mobileMaxHeight+'px');
                            }
                            $(this).closest('.collection-template').find('.section.collection_description').addClass('read-more');
                            $(this).html('Read more').removeClass('show-less');
                        }else{
                            $(this).closest('.collection-template').find('.section.collection_description.read-more').removeClass('read-more');
                            description.css('height', descriptionHeight + 'px');
                            $(this).html('Show less').addClass('show-less');
                        }
                    })

                }
            }
        }else{
            if(descriptionOriginalHeight > desktopMaxHeight){
                if(descriptionHeight != Math.round(descriptionChildHeight) || descriptionChildHeight > desktopMaxHeight){
                    if(descriptionChildHeight < desktopMaxHeight){
                        description.css('height', descriptionChildHeight+'px');
                    }else{
                        description.css('height', desktopMaxHeight+'px');
                    }
                    if(description.hasClass('read-more')) {
                        $('.description-read-more-btn').remove();
                    }
                    description.addClass('read-more')
                    description.after('<div class="description-read-more-btn">Read more</div>');
                    $('.description-read-more-btn').on('click', function () {
                        if($(this).hasClass('show-less')){
                            if(descriptionChildHeight < desktopMaxHeight){
                                description.css('height', descriptionChildHeight+'px');
                            }else{
                                description.css('height', desktopMaxHeight+'px');
                            }
                            $(this).closest('.collection-template').find('.section.collection_description').addClass('read-more');
                            $(this).html('Read more').removeClass('show-less');
                        }else{
                            $(this).closest('.collection-template').find('.section.collection_description.read-more').removeClass('read-more');
                            description.css('height', descriptionHeight + 'px');
                            $(this).html('Show less').addClass('show-less');
                        }
                    })

                }else{
                    $('.description-read-more-btn').remove();
                    $('.section.collection_description.read-more').removeClass('read-more');
                }
            }

        }
      // if (window.matchMedia("(max-width: 768px)").matches) {
      //     if(descriptionHeight > mobileMaxHeight){
      //         if(!description.hasClass('read-more')){
      //             description.addClass('read-more')
      //             description.prepend('<div class="description-read-more-btn">...[read more]</div>');
      //             $('.description-read-more-btn').on('click',function (){
      //                 $(this).closest('.read-more').removeClass('read-more');
      //                 $(this).remove();
      //             })
      //         }
      //     }else{
      //         $('.description-read-more-btn').closest('.read-more').removeClass('read-more');
      //         $('.description-read-more-btn').remove();
      //     }
      // }else{
      //     if(descriptionHeight > desktopMaxHeight){
      //         if(!description.hasClass('read-more')){
      //             description.addClass('read-more')
      //             description.prepend('<div class="description-read-more-btn">...[read more]</div>');
      //             $('.description-read-more-btn').on('click',function (){
      //                 $(this).closest('.read-more').removeClass('read-more');
      //                 $(this).remove();
      //             })
      //         }
      //     }else{
      //         $('.description-read-more-btn').closest('.read-more').removeClass('read-more');
      //         $('.description-read-more-btn').remove();
      //     }
      // }
    }
}
function addImageWithTextReadMore(){
    const description = $('.description.image-with-text-read-more');
    if(description.length > 0){
        /*$('.section.collection_description')[0].scrollHeight*/
        let descriptionOriginalHeight = $('.description.image-with-text-read-more')[0].scrollHeight;
        let blockTitleHeight = $('.description.image-with-text-read-more').closest('.info').find('a.collection_title').outerHeight();
        let blockButtonHeight = $('.description.image-with-text-read-more').closest('.info').find('a.button').outerHeight();
        let blockImageHeight = $('.description.image-with-text-read-more').closest('.featured-link--section').find('.image-element__wrap').outerHeight();
        let descriptionMaxHeight = blockImageHeight - blockButtonHeight - blockTitleHeight - 60;
        let descriptionMobileMaxHeight = 388;
        if (window.matchMedia("(max-width: 768px)").matches) {
            if (descriptionOriginalHeight > descriptionMobileMaxHeight) {
                description.css('height', descriptionMobileMaxHeight + 'px');
                if (description.hasClass('read-more')) {
                    $('.description-read-more-btn').remove();
                }
                description.addClass('read-more')
                description.after('<div class="description-read-more-btn image-with-text-read-more-btn">Read more</div>');
                $('.description-read-more-btn.image-with-text-read-more-btn').on('click', function () {
                    if ($(this).hasClass('show-less')) {
                        description.css('height', descriptionMobileMaxHeight + 'px');
                        $(this).html('Read more').removeClass('show-less');
                    } else {
                        description.css('height', descriptionOriginalHeight + 'px');
                        $(this).html('Show less').addClass('show-less');
                    }
                })
            }
        }else{
            if (descriptionOriginalHeight > descriptionMaxHeight) {
                description.css('height', descriptionMaxHeight + 'px');
                if (description.hasClass('read-more')) {
                    $('.description-read-more-btn').remove();
                }
                description.addClass('read-more')
                description.after('<div class="description-read-more-btn image-with-text-read-more-btn">Read more</div>');
                $('.description-read-more-btn.image-with-text-read-more-btn').on('click', function () {
                    if ($(this).hasClass('show-less')) {
                        description.css('height', descriptionMaxHeight + 'px');
                        $(this).html('Read more').removeClass('show-less');
                    } else {
                        description.css('height', descriptionOriginalHeight + 'px');
                        $(this).html('Show less').addClass('show-less');
                    }
                })
            }
        }
    }
}
$( document ).ready(function() {
    if($('.js-discover-image-slider').length > 0){
        $('.js-discover-image-slider').slick({
            infinite: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: '<span class="slick-prev slick-arrow"><span class="icon icon-left"></span></span>',
            nextArrow: '<span class="slick-next slick-arrow"><span class="icon icon-right"></span></span>',
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                    }
                },
            ]
        });
    }
    if($('.js-magazine-list').length > 0){
        $('.js-magazine-list').slick({
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: '<span class="slick-prev slick-arrow"><svg class="icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 62,90 L 22,50  L 62,10 L 60,0 Z" ></path></svg></span>',
            nextArrow: '<span class="slick-next slick-arrow"><svg class="icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 62,90 L 22,50  L 62,10 L 60,0 Z" transform="translate(100, 100) rotate(180) "></path></svg></span>',
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                    }
                },
            ]
        });
    }
    if($('.js-featured-promotions-slider').length > 0){
        $('.js-featured-promotions-slider').slick({
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: '<span class="slick-prev slick-arrow"><svg class="icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 62,90 L 22,50  L 62,10 L 60,0 Z" ></path></svg></span>',
            nextArrow: '<span class="slick-next slick-arrow"><svg class="icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 62,90 L 22,50  L 62,10 L 60,0 Z" transform="translate(100, 100) rotate(180) "></path></svg></span>',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                    }
                },
            ]
        });
    }
    if($('.js-photo-studio-slider').length > 0){
        $('.js-photo-studio-slider').slick({
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: '<span class="slick-prev slick-arrow"><svg class="icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 62,90 L 22,50  L 62,10 L 60,0 Z" ></path></svg></span>',
            nextArrow: '<span class="slick-next slick-arrow"><svg class="icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 62,90 L 22,50  L 62,10 L 60,0 Z" transform="translate(100, 100) rotate(180) "></path></svg></span>',
            responsive: [
                {
                    breakpoint: 1023,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 475,
                    settings: {
                        slidesToShow: 1,
                    }
                },
            ]
        });
    }
});

function addAcademyReadMoreButton(){
    let paragraph1 = $('.sc-bBHHxi.fhourC.pf-9_');
    let paragraph2 = $('.sc-bBHHxi.fhourC.pf-13_');
    let paragraph3 = $('.sc-bBHHxi.fhourC.pf-11_');
    let wrapper = $('<div class="academy-paragraph-wrapper"></div>');
    let readMoreBtn = $('<div class="academy-read-more-btn">Read more</div>');
    wrapper.css('display','none');
    wrapper.append(paragraph2);
    wrapper.append(paragraph3);
    wrapper.insertAfter(paragraph1);
    readMoreBtn.insertAfter(wrapper);
    $('.academy-read-more-btn').on('click',function (){
        if($('.academy-paragraph-wrapper').hasClass('open')){
            $('.academy-paragraph-wrapper').removeClass('open');
            $('.academy-paragraph-wrapper').slideUp();

            $(this).html('Read more');
        }else{
            $('.academy-paragraph-wrapper').addClass('open');
            $('.academy-paragraph-wrapper').slideDown();
            $(this).html('Read less');
        }
    });
}
addAcademyReadMoreButton();

let sizeChartBtn = document.querySelector('a.chart.size_chart[data-fancybox]');
if(sizeChartBtn){
    sizeChartBtn.addEventListener('click', function (){
        let sizeTables = document.querySelectorAll('.js-sizechart-lightbox table');
        if(sizeTables){
            sizeTables.forEach(function (table){
                if(!table.closest('.sizechart-table-wrapper')){
                    let tableHtml = table.outerHTML;
                    let tableWrapper = document.createElement('div');
                    tableWrapper.classList.add('sizechart-table-wrapper');
                    tableWrapper.innerHTML = tableHtml;

                    table.outerHTML = tableWrapper.outerHTML;
                }
            })
        }

    })
}
let cartPopupBtn = document.querySelectorAll('.js-cart-popup');
if(cartPopupBtn){
    cartPopupBtn.forEach(function (button){
        button.addEventListener('click', function (e){
            e.preventDefault();
            if(this.closest('.cart-container')){
                this.closest('.cart-container').classList.add('popup-open')
                document.body.classList.add('disabled-scroll')
            }
        })
    })
}
document.body.addEventListener("click", function (event) {
    if (event.target.classList.contains("js-cart_content_overflow") || event.target.classList.contains("js-cart_content_top_close") ) {
        if(document.querySelector('.cart-container.popup-open')){
            document.querySelector('.cart-container.popup-open').classList.remove('popup-open')
            if(document.querySelector('.cart-container.active_link')){
                document.querySelector('.cart-container.active_link').classList.remove('active_link')
            }
            document.body.classList.remove('disabled-scroll')
        }
    }
});

let searchClose = document.querySelector('.js-search__form__close-button');
if(searchClose){
    searchClose.addEventListener('click', function (){
        if(this.closest('.search__form__close')){
            this.closest('.search__form__close').style.display = 'none';
        }
    });
}